export enum DayRange {
  wholeDay = 0,
  firstHalf = 1,
  secondHalf = 2
}
